import axios from "axios";
import { toast } from "react-toastify";
import { baseUrl } from "../../nametitle/dataUrl";

// Créer un fidèle
export const CreateFidele = (data) => {
  axios
    .post(`${baseUrl.baseUrl}/api/v1/fideles`, data, {
      headers: {
        Authorization: `Bearer ${baseUrl.token}`,
        "Content-Type": "application/json",
      },
    })
    .then(() => {
      toast.success("Fidèle créé avec succès !");
      window.location.reload();
    })
    .catch((error) => {
      toast.error("Erreur lors de la création du fidèle.");
      console.error(error);
    });
};

// Mise à jour d'un fidèle
export const UpdateFidele = (id, data) => {
  axios
    .put(`${baseUrl.baseUrl}/api/v1/fideles/edit/${id}`, data, {
      headers: {
        Authorization: `Bearer ${baseUrl.token}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      toast.success(response?.data?.message || "Fidèle mise avec succès");
      window.location.reload();
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || "Modification non effectué");
    });
};

// Bloquer un fidèle
export const StopFidele = (id) => {
  axios
    .put(
      `${baseUrl.baseUrl}/api/v1/fideles/hide/${id}`,
      { access: false },
      {
        headers: {
          Authorization: `Bearer ${baseUrl.token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then(() => {
      toast.success("Fidèle bloqué avec succès !");
      window.location.reload();
    })
    .catch((error) => {
      toast.error("Erreur lors du blocage du fidèle.");
      console.error(error);
    });
};

// Débloquer un fidèle
export const AccessFidele = (id) => {
  axios
    .put(
      `${baseUrl.baseUrl}/api/v1/fideles/show/${id}`,
      { access: true },
      {
        headers: {
          Authorization: `Bearer ${baseUrl.token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then(() => {
      toast.success("Fidèle débloqué avec succès !");
      window.location.reload();
    })
    .catch((error) => {
      toast.error("Erreur lors du déblocage du fidèle.");
      console.error(error);
    });
};

// Supprimer un fidèle
export const DeleteFidele = (id) => {
  axios
    .delete(`${baseUrl.baseUrl}/api/v1/fideles/${id}`, {
      headers: {
        Authorization: `Bearer ${baseUrl.token}`,
        "Content-Type": "application/json",
      },
    })
    .then(() => {
      toast.success("Fidèle supprimé avec succès !");
    })
    .catch((error) => {
      toast.error("Erreur lors de la suppression du fidèle.");
      console.error(error);
    });
};



// Charger tous les fidèles
export const LoadAllFideles = (setState) => {
  axios
    .get(`${baseUrl.baseUrl}/api/v1/fideles/get_fideles`, {
      headers: {
        Authorization: `Bearer ${baseUrl.token}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      setState(response.data.data);
    })
    .catch((error) => {
      toast.error("Erreur lors du chargement des fidèles.");
      console.error(error);
    });
};




export const SendEventMessageToFidele = (eventId, fideleId) => {
  axios
    .post(`${baseUrl.baseUrl}/api/v1/fideles/send-event/${eventId}/fidelde/${fideleId}`, {
      headers: {
        Authorization: `Bearer ${baseUrl.token}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      toast.success(response?.data?.message || "Message envoyé avec succès");
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message || "Message non envoyé");
      // console.error(error);
    });
};